import { NofeshOvedSingleReservation } from "./nofesh-oved-single-reservation";

export class IOvdimNofeshSingleReservation
{
    mazmin : NofeshOvedSingleReservation;
    mishtatef : NofeshOvedSingleReservation;
}